import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import ReactSelect from 'react-select';
import { stages } from './homeData';
import PropTypes from 'prop-types';
import { howYouFindUsOptions } from './homeData';

const Page4 = ({ setStage }) => {
  const [findOption, setFindOption] = useState();

  return (
    <>
      <Card className="we-card-shadow">
        <Card.Header className="p-4">
          <Card.Title className="text-uppercase mb-0">
            Enter your information
          </Card.Title>
        </Card.Header>
        <Card.Body className="p-4 pt-0 pb-3">
          <Row className="g-3">
            <Form.Group
              as={Col}
              md="6"
              controlId="Title"
              className="position-relative mb-2"
            >
              <Form.Label className="wr-custom-label left-26">
                Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                className="h-52"
                type="text"
                placeholder="Title"
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide Title
              </Form.Control.Feedback>
            </Form.Group>
            <Col md={6} className="d-none d-md-block" />
            <Form.Group
              as={Col}
              md="6"
              controlId="Full name"
              className="position-relative mb-2"
            >
              <Form.Label className="wr-custom-label left-26">
                Full name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                className="h-52"
                type="text"
                placeholder="Full name"
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide Full name
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group
              as={Col}
              md="6"
              controlId="Last Name"
              className="position-relative mb-2"
            >
              <Form.Label className="wr-custom-label left-26">
                Last Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                className="h-52"
                type="text"
                placeholder="Last Name"
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide Last Name
              </Form.Control.Feedback>
            </Form.Group>
            <Col md={12}>
              <Flex className="mb-2 flex-column flex-md-row">
                <Button
                  variant="outline-secondary"
                  size="lg"
                  className="mb-3 mb-md-0"
                >
                  Non-UK Address
                </Button>
                <Button variant="outline-primary" size="lg" className="ms-md-3">
                  UK Address
                </Button>
              </Flex>
            </Col>
            <Form.Group
              as={Col}
              md="12"
              controlId={`postcode-1`}
              className="position-relative"
            >
              <Form.Label className="wr-custom-label left-26">
                Post Code <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                className="h-52"
                type="text"
                placeholder="Enter your Post Code"
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid zip/post code.
              </Form.Control.Feedback>
            </Form.Group>

            <Col md={12}>
              <p className="mb-0">
                The Post Code search only works for UK, if the billing address
                is outside of the UK, Enter it manually below
              </p>
              <div className="text-center">
                <IconButton
                  className="border-0 shadow-none"
                  variant="falcon-primary"
                  icon={'plus'}
                  iconClassName="me-2"
                >
                  Enter Address Manually
                </IconButton>
              </div>
              <hr />
            </Col>
            <Form.Group as={Col} md={12} className="position-relative">
              <Form.Label className="wr-custom-label left-26">
                How did you hear about us?
              </Form.Label>
              <ReactSelect
                closeMenuOnSelect={true}
                options={howYouFindUsOptions}
                placeholder="Select"
                classNamePrefix="react-select"
                className="wr-donation-amount-currency"
                value={findOption}
                onChange={value => setFindOption(value)}
                menuPosition="fixed"
              />

              <Form.Control.Feedback type="invalid">
                Required
              </Form.Control.Feedback>
            </Form.Group>
            <Col md={12} className="mt-0">
              <hr />

              <Form.Check type="checkbox" id="stay_anonymous" className="my-0">
                <Form.Check.Input type="checkbox" isValid />
                <Form.Check.Label className="ms-1 text-800">
                  Stay Anonymous
                </Form.Check.Label>
              </Form.Check>

              <Form.Check type="checkbox" id="keep_me_update" className="my-0">
                <Form.Check.Input type="checkbox" isValid />
                <Form.Check.Label className="ms-1 text-800">
                  Keep Me updated, I would like to hear from Help Yatemm
                </Form.Check.Label>
              </Form.Check>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Flex
        justifyContent="between"
        alignItems="center"
        className="mt-4 flex-column flex-md-row"
      >
        <Button
          variant="outline-secondary"
          className="h-52 bg-300 hover-bg-primary border-0 w-215px"
          onClick={() => setStage(stages.Donation3)}
        >
          Back
        </Button>
        <Button
          className="h-52 border-0 w-215px mt-3 mt-md-0"
          onClick={() => setStage(stages.Details2)}
        >
          NEXT
        </Button>
      </Flex>
    </>
  );
};

Page4.propTypes = {
  setStage: PropTypes.func.isRequired
};

export default Page4;
